import { FC } from 'react';

import { gettext } from '../Internationalization';
import InternalTextField, { InputElementProps } from './internal/InternalTextField';

export type Props = Omit<InputElementProps, 'select' | 'defaultValue' | 'children'>;

export const PasswordInput: FC<Props> = ({
  id,
  onChange,
  name = 'password',
  label = gettext('Password'),
  required = true,
  autoFocus = false,
}: Props) => {
  return (
    <InternalTextField
      id={id}
      onChange={onChange}
      name={name}
      label={label}
      required={required}
      autoFocus={autoFocus}
      type={'password'}
      autoComplete={'password'}
      children={undefined}
      defaultValue={undefined}
      select={false}
    />
  );
};

export default PasswordInput;
